import React, { Component } from 'react'
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { Container, Divider,Button, TextField,Badge,InputAdornment,Link,Fab } from '@mui/material';
import logo from "../src/logo.png"
import PersonIcon from '@mui/icons-material/Person';
import SearchIcon from '@mui/icons-material/Search';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ww from './ww.webp'
import bg2 from './bachround_img/bg.jpg'
import HomeIcon from '@mui/icons-material/Home';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import AddIcCallIcon from '@mui/icons-material/AddIcCall';
import HandshakeIcon from '@mui/icons-material/Handshake';
import Groups2Icon from '@mui/icons-material/Groups2';

import MenuIcon from '@mui/icons-material/Menu';



export class Appbar extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
      anchorEl : null,
      open: false,

       

      wishCount : 0,
      cartCount : 0,
      email :null
    }
    this.setAnchorEl = this.setAnchorEl.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.handleClose = this.handleClose.bind(this)
  }



  handleClick(event) {
    this.setAnchorEl(event.currentTarget);
  }


    setAnchorEl(value){
        this.setState({
            anchorEl: value,
            open: !this.state.open
        })
    }


  async  componentDidMount() {
      this.intervalId = setInterval(this.rr, 100); // Fetch data every 1 second
        this.setState({
          email : await localStorage.getItem("email")
        })
    }
  
    componentWillUnmount() {
      clearInterval(this.intervalId); // Clear interval on unmount
    }


    rr=()=>{
this.setState({
  wishCount : sessionStorage.getItem('wishListCount'),
  cartCount : sessionStorage.getItem('cartListCount')
})
    }


   

handleClose() {
    this.setAnchorEl(null);
}





renderMenu(){
  
  return(
    <Box sx={{}}>
  <Menu id="fade-menu" anchorEl={this.state.anchorEl} open={this.state.open}  onClose={this.handleClose}>
     <Box sx={{minHeight:50,width:200,backgroundColor:'#fff'}}>
   <Typography textAlign='center' sx={{fontSize:16,fontWeight:'600',mt:1}}>MY ACCOUNT</Typography>
   <Typography textAlign='center' sx={{fontWeight:'500',fontSize:13,mt:1,display:this.state.email!=null?'none':'flex'}}>Login to access your account</Typography>

   <Box sx={{display:this.state.email!=null?'none':'flex',justifyContent:'space-between',flexDirection:'row',padding:2}}>
<Link href='/login'>
<Button variant='outlined'  size='small' sx={{fontSize:12,borderColor:'#ab266c',color:'#ab266c'}}>Sign in</Button>
</Link>

<Link href='/register'>
<Button variant='contained'  onClick={()=>this.props.navigation.navigate('/registration')} size='small' sx={{fontSize:12,backgroundColor:'#ab266c'}}>Sign up</Button>
</Link>
   </Box>

     </Box>

        
       <MenuItem onClick={this.handleClose}   sx={{fontSize:15}}><Link sx={{textDecoration:'none',color:'black'}} href='/sellers'>Become a seller</Link></MenuItem>
       <MenuItem onClick={this.handleClose}   sx={{fontSize:15}}><Link sx={{textDecoration:'none',color:'black'}} href='/orderList'>Your orders</Link></MenuItem>
        <MenuItem onClick={this.handleClose}   sx={{fontSize:15}}><Link sx={{textDecoration:'none',color:'black'}} href='/wishList'>Wish List</Link></MenuItem>
                <MenuItem onClick={this.handleClose}   sx={{fontSize:15}}><Link sx={{textDecoration:'none',color:'black'}} href='/contact'>Contact us</Link></MenuItem>
        <MenuItem onClick={()=>{localStorage.clear();window.open('/','_self')}} sx={{fontSize:15}} >Log out</MenuItem>
  </Menu>
    </Box>
   )
}

  render() {
   
    return (
      <div>
      <Box>
      


      <AppBar position="fixed" sx={{display:'flex',justifyContent:'center',alignItems:'center',borderBottom:2,borderBottomColor:'#c7167a', backgroundImage: `url(${bg2})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          minHeight: 55, // Mandatory for visibility if content is empty
          width: '100%'}}>
       <Container maxWidth='xl'>
      <Toolbar variant="dense">
     


       <Box sx={{flex:1,flexDirection:'row',marginLeft:{xs:-3,sm:0,md:0,lg:0}}}>
        <Box sx={{display:'flex',flexDirection:'row',justifyContent:'left',alignItems:'center'}}>

  <img alt='logo' src={logo} style={{height:40,objectFit:'contain',marginRight:16}}/>

<Link sx={{textDecoration:'none'}} href='/'>
<Box sx={{display:{xs:'none',sm:'flex',md:'flex'},flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
<HomeIcon sx={{color:'black',height:20,width:20}}/>
<Typography sx={{fontSize:12,fontWeight:'500',color:'black'}}>Home</Typography>
</Box>
</Link>

<Link sx={{textDecoration:'none'}} href='/wishList'>
<Box sx={{display:{xs:'none',sm:'flex',md:'flex'},flexDirection:'column',ml:3,justifyContent:'center',alignItems:'center'}}>
<MenuBookIcon sx={{color:'black',height:20,width:20}}/>
<Typography sx={{fontSize:12,fontWeight:'500',color:'black'}}>Wish List</Typography>
</Box>
</Link>



<Link sx={{textDecoration:'none'}} href='/sellers'>
<Box  sx={{display:{xs:'none',sm:'flex',md:'flex'},flexDirection:'column',ml:3,justifyContent:'center',alignItems:'center'}}>
<Groups2Icon sx={{color:'black',height:20,width:20}}/>
<Typography sx={{fontSize:12,fontWeight:'500',color:'black'}}>Become a seller</Typography>
</Box></Link>

<Link sx={{textDecoration:'none',display:{xs:'none',sm:'flex',md:'flex'}}} href='/contact'>
<Box sx={{display:'flex',flexDirection:'column',ml:3,justifyContent:'center',alignItems:'center'}}>

  <AddIcCallIcon color="action" sx={{color:'black',height:20,width:20}}/>

<Typography sx={{fontSize:12,fontWeight:'500',color:'black'}}>Contact us</Typography>
</Box>
</Link>



        </Box>

       </Box> 



       <Box sx={{flex:1,flexDirection:'row',marginLeft:{xs:-3,sm:0,md:0,lg:0}}}>
  <Box sx={{display:'flex',flexDirection:'row',justifyContent:'right',alignItems:'center'}}>
    
     <TextField variant='outlined'  InputProps={{sx:{fontSize:10,borderRadius:20}}} slotProps={{
            input: {
              endAdornment: <Link href='/itemList'> <IconButton><SearchIcon sx={{color:'#1d294f'}}/></IconButton></Link>,
            },
          }}   placeholder='Search somethings...' fullWidth size='small' sx={{display:{xs:'none',sm:'block',md:'block'},backgroundColor:'#d0be96',width:'30%',"& .MuiOutlinedInput-root": {
      borderRadius: "30px", // Increase for pill shape
    },}}/>

<Link sx={{display:{xs:'none',sm:'flex',md:'flex'}}} href='/cartList'>
<Box sx={{display:'flex',flexDirection:'column',ml:3}} >
<Badge  badgeContent={this.state.cartCount} color="primary">
  <ShoppingCartIcon color="action" sx={{color:'black',height:20,width:20}}/>
</Badge>
<Typography sx={{fontSize:12,fontWeight:'500',color:'black'}}>Cart</Typography>
</Box>
</Link>


<Box sx={{display:{xs:'flex',sm:'none',md:'none'}}} aria-owns={this.state.open ? 'fade-menu' : undefined} aria-haspopup="true" onClick={this.handleClick}>
<IconButton sx={{mr:-3}} aria-label="menu" >
  <MenuIcon  sx={{height:40,width:40}}/>
</IconButton>
{this.renderMenu()}
</Box>


       </Box>

       </Box>




      </Toolbar> 
      </Container>
      </AppBar>
   


 </Box>
      </div>
    )
  }
}

export default Appbar



